import { setComponentMapOverrides } from '@jutro/uiconfig';

import BaseFNOLWizard from './BaseFNOLWizard';
import FNOLSelectPolicy from './pages/FNOLSelectPolicy/FNOLSelectPolicy';
import FNOLSummaryPage from './pages/Summary/SummaryPage';
import FNOLContactDetailsPage from './pages/ContactDetails/ContactDetailsPage';
import FNOLWherePage from './pages/Where/WherePage';
import ClaimsConfirmationPage from './pages/ConfirmationPage/ConfirmationPage';
import Claim from './models/Claim';
import Contact from './models/Contact';
import Address from './models/Address';
import FNOLTypeOfIncidentPage from './pages/TypeOfIncident/TypeOfIncidentPage';
import FNOLCPTypeOfIncidentPage from './common/CommercialProperty/TypeOfIncident/TypeOfIncidentPage';
import FNOLPLTypeOfIncidentPage from './common/ProfessionalLiability/TypeOfIncident/TypeOfIncidentPage';
import FNOLCPWherePage from './common/CommercialProperty/Where/WherePage';
import FNOLPLWherePage from './common/ProfessionalLiability/Where/WherePage';

import ClaimUtil from './utils/ClaimUtil';
import VehicleDamagePicker from './components/VehicleCollision/VehicleDamagePicker';

setComponentMapOverrides(
    {
        BaseFNOLWizard: { component: 'BaseFNOLWizard' },
        FNOLSelectPolicy: { component: 'FNOLSelectPolicy' },
        FNOLSummaryPage: { component: 'FNOLSummaryPage' },
        FNOLContactDetailsPage: { component: 'FNOLContactDetailsPage' },
        FNOLTypeOfIncidentPage: { component: 'FNOLTypeOfIncidentPage' },
        FNOLWherePage: { component: 'FNOLWherePage' },
        ClaimsConfirmationPage: { component: 'ClaimsConfirmationPage' },
        FNOLCPTypeOfIncidentPage: { component: 'FNOLCPTypeOfIncidentPage' },
        FNOLPLTypeOfIncidentPage: { component: 'FNOLPLTypeOfIncidentPage' },
        FNOLCPWherePage: { component: 'FNOLCPWherePage' },
        FNOLPLWherePage: { component: 'FNOLPLWherePage' }
    },
    {
        BaseFNOLWizard,
        FNOLSelectPolicy,
        FNOLSummaryPage,
        FNOLContactDetailsPage,
        FNOLTypeOfIncidentPage,
        FNOLWherePage,
        ClaimsConfirmationPage,
        FNOLCPTypeOfIncidentPage,
        FNOLPLTypeOfIncidentPage,
        FNOLCPWherePage,
        FNOLPLWherePage
    }
);

export {
    BaseFNOLWizard as default,
    Claim,
    ClaimsConfirmationPage,
    Contact,
    Address,
    ClaimUtil,
    VehicleDamagePicker
};
export { default as FNOLLossLocation } from './components/LossLocation/LossLocation';
export { default as fnolCommonMessages } from './FNOL.messages';
